function beforeAnimation(element) {
	setTimeout(() => {
        element.classList.add("opac-100");
	}, 500);
}

function animateNumber(element, target, duration = 2000, decimalPlaces = 2) {
	let start = 0;
	let startTime = null;
	
	beforeAnimation(element);
	
	function updateNumber(timestamp) {
		console.log(timestamp);
		if(!startTime)
			startTime = timestamp;
		
		const elapsed = timestamp - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const currentNumber = start + progress * (target - start);
		
		element.textContent = target % 1 === 0 ? Math.round(currentNumber).toLocaleString() : currentNumber.toFixed(decimalPlaces).toLocaleString();
		
		if(progress < 1) {
			requestAnimationFrame(updateNumber);
		} else {
			element.textContent = target.toLocaleString();
		}
	}
	
	requestAnimationFrame(updateNumber);
}
	
function initLazyLoad() {
    const elements = document.querySelectorAll(".animated-number");
    const observer = new IntersectionObserver ((entries, observer) => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const element = entry.target;
                const target = parseFloat(element.getAttribute("data-target"));
                
                if(!isNaN(target) && !element.dataset.animated) {
                    element.dataset.animated = "true";
                    setTimeout(() => { 
                        animateNumber(element, target, 400);
                    }, 100);
                }
            }
        });
    }, { threshold: 0.5 });
    
    elements.forEach(element => observer.observe(element));
}

setTimeout(initLazyLoad, 500);